import React from 'react';
import { connect } from 'react-redux';
import { connect as connectFormik } from "formik";
import BbInput from '../styling/bbInput';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { domainActions } from '../../store/domainStore';
import { hasPermission } from '../../store/apiWrapper';
import SelectOption from '../searchSections/selectOption';

class RatioBookYearsField extends React.Component {

    componentDidMount() {
        this.props.ensureDomainData('ratiobookyears');
    }

    componentDidUpdate() {
        this.props.ensureDomainData('ratiobookyears');
    }

    render() {
        let years = this.filterYears();
        return (
            <BbInput type='select-noformik' label={this.props.translate('RatioBook.Common.Year')} placeholder={{ type: 'column' }}
                formatOptionLabel={SelectOption}
                value={(years.find(op => {
                    return op.value === this.props.year
                }) || {})}
                options={years}
                onChange={(e) => this.props.onChange(e.value)}
            />
        )
    }

    filterYears() {
        var source = this.props.ratiobookyears.requestResult ? this.props.ratiobookyears.requestResult : [];
        var o = [];
        source.forEach((i) => {
            if (hasPermission(null, "RatioBook" + i.value))
                o.push(i);
        });
        return o;
    }
}

export default connectFormik(withLocalize(connect(
    state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch))
    (RatioBookYearsField)));